module.exports = __webpack_public_path__ + "img/img-status-error.8217f155.png";